import styled from '@emotion/styled';

export const PreBookingWarning = styled.div`
  padding: 10px 20px;
  background: ${(props) => props.theme.color.blue.light};
  color: ${(props) => props.theme.color.blue.default};
  border-radius: 10px;
  margin: 10px 0;
  p {
    margin: 0;
  }
`;

export const Label = styled.div`
  font-weight: 700;
  color: ${(props) => props.theme.color.blue.default};
`;
